import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageTitle from "../components/PageTitle";
import ServiziListElement from "../components/ServiziListElement";
import useSEO from "../hooks/useSEO";

// Import service images
import igieneImg from "../assets/services/igiene.png";
import conservativaImg from "../assets/services/carie.png";
import esteticaImg from "../assets/services/estetica.png";
import chirurgiaImg from "../assets/services/chirurgua.png";
import protesiImg from "../assets/services/protesi-dent.png";
import ortodonziaImg from "../assets/services/ortodonzia.png";
import gnatologiaImg from "../assets/services/gnatologia.png";
import implantologiaImg  from "../assets/services/protesi.png";
import emergenzaImg from "../assets/services/emergenza.png";

function Servizi() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const servizi = [
    {
      Icon: igieneImg,
      Title: t('Servizi.services.hygiene.title'),
      Description: t('Servizi.services.hygiene.description'),
    },
    {
      Icon: conservativaImg,
      Title: t('Servizi.services.conservative.title'),
      Description: t('Servizi.services.conservative.description'),
    },    
    {
      Icon: esteticaImg,
      Title: t('Servizi.services.aesthetic.title'),
      Description: t('Servizi.services.aesthetic.description'),
    },  {
      Icon: chirurgiaImg,
      Title: t('Servizi.services.surgery.title'),
      Description: t('Servizi.services.surgery.description'),
    },  {
      Icon: implantologiaImg,
      Title: t('Servizi.services.implantology.title'),
      Description: t('Servizi.services.implantology.description'),
    },  {
      Icon: ortodonziaImg,
      Title: t('Servizi.services.orthodontics.title'),
      Description: t('Servizi.services.orthodontics.description'),
    },  {
      Icon: gnatologiaImg,
      Title: "Gnatologia",
      Description: "Terapie individualizzate per la cura dei disturbi dell’articolazione temporo-mandibolare",
    },  {
      Icon: protesiImg,
      Title: t('Servizi.services.prosthetics.title'),
      Description: t('Servizi.services.prosthetics.description'),
    },  
    {
      Icon: emergenzaImg,
      Title: t('Servizi.services.emergency.title'),
      Description: t('Servizi.services.emergency.description'),
    },
  ];

  // SEO Configuration
  useSEO({
    title: t('Servizi.seoTitle'),
    description: t('Servizi.seoDescription'),
    keywords: t('Servizi.seoKeywords'),
    schema: {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "Studio Dentistico Sgarbini",
      "description": "Studio dentistico specializzato in odontoiatria generale, igiene e prevenzione",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Via Camilla 10/a",
        "addressLocality": "Roma",
        "addressCountry": "IT"
      },
      "telephone": "+39 06 7886902",
      "medicalSpecialty": ["Odontoiatria", "Igiene dentale", "Conservativa"],
      "priceRange": "€€"
    }
  });

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-2 py-10 z-0">
      <div
        className={`
          transition-all duration-700
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
        `}
      >
        <PageTitle title={t('Servizi.title')} />
        <div className="mb-8 mt-4 text-lg text-gray-700 text-center md:text-left max-w-2xl mx-auto">
          {t('Servizi.description')}
        </div>
        <div className="flex flex-col gap-6">
          {servizi.map((servizio) => (
            <ServiziListElement
              key={servizio.Title}
              Icon={servizio.Icon}
              Title={servizio.Title}
              Description={servizio.Description}
              open={openIdx === servizi.indexOf(servizio)}
              onClick={() => {
                const idx = servizi.indexOf(servizio);
                setOpenIdx(openIdx === idx ? null : idx);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Servizi;
